import { useState, useCallback } from 'react';
import type { CreateUserForm, TeamMemberRole } from '../../types/team.types';
import { defaultUserFormValues } from '../../constants/team.constants';

export function useUserForm(initialValues: Partial<CreateUserForm> = {}) {
  const [values, setValues] = useState<CreateUserForm>({
    ...defaultUserFormValues,
    ...initialValues,
  });

  const handleChange = useCallback((field: keyof CreateUserForm, value: string | TeamMemberRole) => {
    if (typeof value === 'string') {
      if (field === 'phone') {
        // Allow only a leading '+' at position 0 followed by digits; block everything else
        if (!/^\+?\d*$/.test(value)) return;
        // Block '+' in any position other than the first character
        if (value.indexOf('+') > 0) return;
        // Enforce '+' prefix automatically when the first digit is typed without '+'
        // (no forced prefix; '+' must be typed manually per spec)
      }
      if (field === 'email' && /\s/.test(value)) return;
    }
    setValues((prev) => ({ ...prev, [field]: value }));
  }, []);

  const resetForm = useCallback((newValues: Partial<CreateUserForm> = {}) => {
    setValues({ ...defaultUserFormValues, ...newValues });
  }, []);

  return {
    values,
    setValues,
    handleChange,
    resetForm,
  };
}
